import { EMPTY_LIST } from '../../../../constants/common'
import {
  getIsApplicantFieldMasked,
  getIsRentalPortalApplicantIdentityMasked,
  getRentalPortalApplicantIdentityLabel,
} from '../../../RentalPortalApplicant'

import {
  APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT,
  APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_LIMIT,
} from './RentalPortalApplicantProfileDocuments.constants'

function getApplicantOutstandingChecklistRows(applicantData) {
  const missingKeys = new Set(applicantData?.documents?.missing ?? EMPTY_LIST)

  return (applicantData?.checklist ?? EMPTY_LIST).filter(row =>
    missingKeys.has(row.key)
  )
}

export function getIsApplicantDocumentsEmpty({ documents, isInitiated }) {
  const hasDocuments = documents?.length > 0

  return isInitiated && !hasDocuments
}

export function getApplicantDocumentsEmptyState(applicantData) {
  if (getIsRentalPortalApplicantIdentityMasked(applicantData)) {
    return {
      hiddenCount: 0,
      outstanding: EMPTY_LIST,
      textKey: 'RentalPortal.ApplicantProfileDocumentsMaskedEmptyKey',
    }
  }

  const rows = getApplicantOutstandingChecklistRows(applicantData)

  return {
    hiddenCount: Math.max(
      rows.length - APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_LIMIT,
      0
    ),
    outstanding: rows.slice(0, APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_LIMIT),
    textKey:
      rows.length > 0
        ? 'RentalPortal.ApplicantProfileDocumentsEmptyKey'
        : 'RentalPortal.ApplicantProfileDocumentsNoneOutstandingKey',
  }
}

export function getApplicantDocumentsRootBreadcrumbs({ applicantData, t }) {
  return [
    {
      id: APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT,
      title: getRentalPortalApplicantIdentityLabel({
        applicant: applicantData,
        t,
      }),
    },
  ]
}

export function getIsApplicantDocumentsFolderAvailable(applicantData) {
  return (
    !getIsApplicantFieldMasked(applicantData?.identity) &&
    Boolean(applicantData?.directory_id)
  )
}

export function getApplicantDocumentsFolderEmptyKey(applicantData) {
  return getIsApplicantFieldMasked(applicantData?.identity)
    ? 'RentalPortal.ApplicantProfileDocumentsMaskedEmptyKey'
    : 'RentalPortal.ApplicantProfileDocumentsNoFolderKey'
}
